import React from 'react';

export const LogoContext = React.createContext(null);